import React, { useCallback, useEffect } from "react";
import { Transport } from "@EUForms/transport";
import { useTranslation } from "@hooks/useTranslation";
import { GoodLocationForm } from "@EUForms/transport/import/goodLocationForm";
import WareHouseDetail from "./wareHouseDetail";
import { useDocument } from '@EUForms/hooks/useDocument'
import { CustomLoader } from "@commonComponents/formComponents/loader";
import AdditionalDocDetail from "./additionalDocDetail";
import RepeatableContainer from "@containers/repeatableContainer";
import CountryInfoDetail from "./countryInfoDetail";
import { useEvent } from "@hooks/useEvent"
import GoodLocationDetail from "./goodLocationDetail";
import BorderTransportDetail from "./borderTransportDetail";
import ArrivalTransportDetail from "./arrivalTransportDetail";
import DepartureTransportDetail from "./departureTransportDetail";
import { useDispatch, useSelector } from "react-redux";
import { selectProcedure, selectCountryList, selectLocationOfGoodsDS } from "@EUForms/selectors";
import TerminalDetail from "./terminalDetail";
import { transportTabActions } from "../../reducer/transportSlice";
import AirFreight from "./airFreight";
import { useValidateDecByDispatchCntry } from "../../hooks";
import { useCustomOffices } from "@EUForms/hooks/useCustomOffices";
import { useCurrentShipmentType } from "@hooks/useCurrentShipmentType";
import SecurityInfoDetail from "./securityInfoDetail";
import CustomofficeDetail from "./customofficeDetail";
import { FormTitle } from "@commonComponents/FormTitle";

const TransportContainer = () => {
  const translate = useTranslation()
  const { addItemTransport, deleteItemTransport, updateItemTransport, updateTransportDetails, updateTransportHeaderInfo } = transportTabActions
  const { isLoading, ...rest } = useDocument({ addData: addItemTransport, deleteData: deleteItemTransport, updateData: updateItemTransport, containerKey: "transportTab" })
  const { isLoading: Loading, ...restData } = useCustomOffices({ addData: addItemTransport, deleteData: deleteItemTransport, updateData: updateItemTransport, containerKey: "transportTab" })
  const { saveForm } = useEvent("transportTab")
  const procedure = useSelector(selectProcedure)
  const isProcI2AorB = ["I2A", "I2B"].includes(procedure)
  const countryList = useSelector(selectCountryList)
  const dataSource = useSelector(selectLocationOfGoodsDS)
  const { isImportShipment,currentJobState,isDisabled} = useCurrentShipmentType()
  const response = useValidateDecByDispatchCntry(countryList, isImportShipment)
  const dispatch = useDispatch()
  //const arrivalLength =useSelector(selectArrivalTransportLength);

  useEffect(() => {
    // initialize default data on load if it is not present
    if (dataSource.id) {
      const otherFields = {}
      if (!dataSource.country)
        otherFields.country = "NL"
      if (!dataSource.type)
        otherFields.type = "B"

      if (Object.keys(otherFields).length > 0) {
        otherFields.id = dataSource.id
        dispatch(updateTransportDetails({ key: "locationOfGoods", data: otherFields }))
        saveForm({ "locationOfGoods": otherFields })
      }
    }
  }, [dataSource.id])

  const borderTransportForm = useCallback((params) => <Transport.TransportModeForm countryList={countryList} {...params} isRepeatable={false} />, [])
  const transportForm = useCallback((params) => <Transport.TransportModeForm countryList={countryList} {...params} isRepeatable={false} />, [])

  const terminalForm = useCallback((params) => <Transport.TerminalForm {...params} translate={translate} className="grow self-end mb-2" />, [])
  const enableAdditionalDocs =["STATE_ENTRY_EXT_IN_PROCESS","STATE_ENTRY_EXT_READY"].includes(currentJobState)

  return (

    <div className="transportContainer formContentareaC88">
      {isLoading && <CustomLoader style={{ position: "fixed" }} />}
      <Transport>
        <div className="row border-0">
          <CountryInfoDetail
            saveData={saveForm}
            updateData={updateTransportDetails}
            renderForm={(params) => <Transport.CountryInfoForm countryList={countryList} {...params} />}
          />
          {isImportShipment && <AirFreight
            saveData={saveForm}
            // updateData={updateTransportHeaderInfo}
            updateData={updateTransportDetails}
          />}
        </div>
        <div className="row border-0">
          <GoodLocationDetail
            className="grow self-end mb-2"
            dataSource={dataSource}
            saveData={saveForm}
            updateData={updateTransportDetails}
            translate={translate}
            renderForm={(params) => <GoodLocationForm houseNumberStyle={{ minWidth: '360px' }} countryList={countryList} {...params} />}
          />
          {!isProcI2AorB && <WareHouseDetail
            saveData={saveForm}
            updateData={updateTransportDetails}
            renderForm={(params) => <Transport.WareHouseDetailForm {...params} wareHouseBoxNo="2/7" className="grow mb-2" />}
          />}
        </div>
        {!isProcI2AorB && <BorderTransportDetail
          updateData={updateTransportHeaderInfo} {...rest}
          translate={translate}
          renderForm={borderTransportForm}
          saveData={saveForm}
        />}
        {!isImportShipment && (
          <div className="col formContainer">
            <FormTitle className="formTitle" textAlign="start" boxNumber="7/7" title="DEPARTURE_TRANSPORT_MEANS"  />
            <RepeatableContainer
              {...rest}
              tableName="departureTransportMeansList"
              // boxNumber="7/7"
              reducerName="transportReducer"
              // title="DEPARTURE_TRANSPORT_MEANS"
              translate={translate}
              renderForm={(params) => <DepartureTransportDetail
                {...params}
                renderForm={(props) => <div className="formContainer">
                  <Transport.TransportModeForm
                    countryList={countryList}
                    {...props} />
                </div>}
              />}
            />
          </div>
        )}
        {!isImportShipment && <Transport.RoutingCountry limit={10} countryList={countryList} countryCode='NL' {...rest} />}
        {
          isImportShipment && <div className="row border-0">
            {!isProcI2AorB && <ArrivalTransportDetail
              {...rest}
              translate={translate}
              renderForm={transportForm}
            />}
            <TerminalDetail
              isImportShipment={isImportShipment}
              saveData={saveForm}
              updateData={updateTransportHeaderInfo}
              renderForm={terminalForm}
            />
          </div>
        }
        {!isImportShipment && <>
          {/* <DepartureTransportDetail  {...rest} translate={translate} renderForm={transportForm}  />  */}
          <SecurityInfoDetail
            saveData={saveForm}
            updateData={updateTransportHeaderInfo}
            renderForm={(params) => <Transport.SecurityInfoForm {...params} />}
          />
        </>}
      </Transport>

      {!isProcI2AorB && <RepeatableContainer
        {...restData}
        tableName="customOfficesList"
        reducerName="transportReducer"
        title="CUSTOMS OFFICES"
        maxRowsAllowed={3}
        translate={translate}
        renderForm={(params) => <CustomofficeDetail inputType="dropdown"  {...params} />}
      />
      }
      <RepeatableContainer
        {...rest}
        tableName="additionalDocumentsList"
        reducerName="transportReducer"
        title="ADDITIONAL DOCUMENT"
        translate={translate}
        boxNumber="2/2"
        isDisabled={enableAdditionalDocs? false : isDisabled}
        renderForm={(params) => <AdditionalDocDetail {...params} isDisabled={enableAdditionalDocs? false : isDisabled}/>}
      />

    </div>

  );
}

export default React.memo(TransportContainer)
